import ApiClient from "../helpers/ApiClient";


export const addNews = async ({ title, description, date, file }) => {
    try {
        const response = await ApiClient.post(`/galleryAndNews/addNews`,
            {  title, description, date, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}



export const createGalleryAlbum = async ({ album_name }) => {
    try {
        const response = await ApiClient.post(`/galleryAndNews/addAlbum`, { album_name });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}
export const getGalleryAlbumData = async () => {
    try {
        const response = await ApiClient.get(`/galleryAndNews/getAlbum`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const addImageData = async ({ album_id, file }) => {
    try {
        const response = await ApiClient.post(`/galleryAndNews/addImages`,
            {  album_id, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteImageData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/galleryAndNews/deleteImages/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteAlbumData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/galleryAndNews/deleteAlbum/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}